import { saveAs } from 'file-saver';

const exportData = (data, selectedYear) => {
    const csvArray = [];
    let headers = '';
    headers += 'MBID,';
    headers += 'Benchmarking Group,';
    headers += 'Building Name,';
    headers += 'Reporting Year,';
    headers += 'Building Status,';
    headers += 'Street,';
    headers += 'City,';
    headers += 'State,';
    headers += 'Postal Code,';
    headers += 'Year Built,';
    headers += 'Building Count,';
    headers += 'Primary Property Type EPA Calculated,';
    headers += 'All Property Use Types + GFA,';
    headers += 'Reported GFA,';
    headers += 'Electricity Use Grid Purchase (kWh),';
    headers += 'Electricity Use Onsite Renewable (kWh),';
    headers += 'Natural Gas Use (therms),';
    headers += 'Site EUI (kBtu/ft2),';
    headers += 'Weather Normalized Site EUI (kBtu/ft2),';
    headers += 'Total GHG Emissions (Metric Tons CO2e),';
    headers += 'Total GHG Emissions Intensity (kgCO2e/ft2),';
    headers += 'Direct GHG Emissions (Metric Tons CO2e),';
    headers += 'Direct GHG Emissions Intensity (kgCO2e/ft2),';
    headers += 'Normalized Net Site EUI (kBtu/ft2),';
    headers += 'Baseline Performance (kBtu/ft2),';
    headers += 'Projected Interim Performance Standard (kBtu/ft2),';
    headers += 'Projected Final Performance Standard (kBtu/ft2),';
    headers += 'Meeting Final Standard';

    csvArray.push(headers);

    data.forEach(building => {
        if (building.benchmarking_group.toLowerCase().includes('covered')) return;
        const line = [];
        line.push('\'' + building.building_id);
        sanitizeString(line, building, 'benchmarking_group');
        sanitizeString(line, building, 'building_name');
        line.push(selectedYear);
        sanitizeString(line, building, 'status');
        sanitizeString(line, building, 'street');
        sanitizeString(line, building, 'city');
        sanitizeString(line, building, 'state_short');
        sanitizeString(line, building, 'postal_code');
        sanitizeString(line, building, 'year_built');
        pushPropertyOrUndisclosed(line, building, 'building_count', selectedYear);
        pushPropertyOrUndisclosed(line, building, 'primary_property_type_epa_calculated', selectedYear);
        pushPropertyOrUndisclosed(line, building, 'list_of_all_property_use_types_at_property_and_gfa', selectedYear);
        pushPropertyOrUndisclosed(line, building, 'gfa_reported', selectedYear);
        pushPropertyOrUndisclosed(line, building, 'electricity_use_grid_purchase_kwh', selectedYear);
        pushPropertyOrUndisclosed(line, building, 'electricity_use_onsite_renewable_system_electricity_used_onsite', selectedYear);
        pushPropertyOrUndisclosed(line, building, 'natural_gas_use_therms', selectedYear);
        pushPropertyOrUndisclosed(line, building, 'site_eui', selectedYear);
        pushPropertyOrUndisclosed(line, building, 'weather_normalized_site_eui', selectedYear);
        pushPropertyOrUndisclosed(line, building, 'total_location_based_ghg_emissions', selectedYear);
        pushPropertyOrUndisclosed(line, building, 'total_location_based_ghg_emissions_intensity', selectedYear);
        pushPropertyOrUndisclosed(line, building, 'direct_ghg_emissions', selectedYear);
        pushPropertyOrUndisclosed(line, building, 'direct_ghg_emissions_intensity', selectedYear);
        pushPropertyOrUndisclosed(line, building, 'normalized_net_site_eui', selectedYear);
        extraProcessingNeeded(line, building, 'baseline_performance_standard', selectedYear);
        extraProcessingNeeded(line, building, 'interim_performance_standard', selectedYear);
        pushPropertyOrUndisclosed(line, building, 'final_performance_standard', selectedYear);
        pushPropertyOrUndisclosed(line, building, 'meeting_final_standard', selectedYear);

        csvArray.push(line.join(','));
    });

    const csvString = csvArray.join("\n");
    const blob = new Blob([csvString], { type: 'text/csv' });
    saveAs(blob, 'Montgomery County Building Energy Performance Map Export ' + selectedYear + '.csv');
}

const pushPropertyOrUndisclosed = (lineArray, building, property, year) => {
    if (Number.parseInt(building.reporting_start_date) === Number.parseInt(year)) lineArray.push('Undisclosed');
    else sanitizeString(lineArray, building, property);
}

const extraProcessingNeeded = (lineArray, building, property, year) => {
    if (Number.parseInt(building.reporting_start_date) === Number.parseInt(year)) lineArray.push('Undisclosed');
    else if (building.status === 'not submitted' && Number.parseInt(building.reporting_start_date) === year - 1) lineArray.push('TBD');
    else sanitizeString(lineArray, building, property);
}

const sanitizeString = (lineArray, building, property) => {
    if (typeof building[property] === 'string') lineArray.push((building[property].replaceAll(',', ';')));
    else lineArray.push(building[property]);
}

export default exportData;
